import * as React from "react";
import {
  View,
  ImageBackground,
  TouchableOpacity,
  ActivityIndicator,
  Alert,
  Dimensions,
  ToastAndroid,
  StyleSheet,
  TextInput,
} from "react-native";
import colors from "@constants/color";
import CloseIcon from "@assets/svg/CloseIcon";
import Text from "@components/AppText";
import ImageIcon from "@assets/svg/UploadImageIcon";
import { fontFamily } from "@utils/styles";
import imagePickerHelper from "@utils/imagePickerHelper";

const AddPhotoButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        height: (Dimensions.get("screen").width - 65) / 2,
        width: (Dimensions.get("screen").width - 65) / 2,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: "rgba(0, 0, 0, 0.2)",
        backgroundColor: "white",
        alignItems: "center",
        justifyContent: "center",
        borderStyle: "dashed",
        marginBottom: 10,
      }}
    >
      <ImageIcon />
      <Text
        variant="body_text_4"
        style={{ marginLeft: 7, color: colors.primary, marginTop: 6 }}
      >
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const Label = ({ label, type }) => (
  <View style={{ marginVertical: 10, flexDirection: "row" }}>
    <Text
      variant="subtitle_16"
      style={{
        color: colors.black,
        fontFamily: fontFamily.semiBold,
        fontSize: 16,
      }}
    >
      {label}
    </Text>
    {type && type === "images" && (
      <Text
        style={{
          color: colors.black,
          fontFamily: fontFamily.semiBold,
          fontSize: 16,
        }}
      >
        {"  "}
      </Text>
    )}
  </View>
);

const ImagesUpload = ({
  key,
  rvpData,
  reason,
  imageRequired,
  currentImgs,
  setUploadedImage,
}) => {
  const [srcMap, setSrcMap] = React.useState(currentImgs);

  const { select_images_text, max_image_count } = rvpData;

  const remove = (id) => {
    const itemIdx = srcMap.findIndex((src) => src.id === id);
    if (itemIdx !== -1) {
      srcMap.splice(itemIdx, 1);
      const srcMapCopy = srcMap.slice();
      setSrcMap(srcMapCopy);
      setUploadedImage(reason.key, srcMapCopy);
    }
  };

  const updateSrc = (newMap) => {
    setSrcMap([...srcMap, newMap]);
  };

  const updateUrlRef = React.useRef();
  updateUrlRef.current = (id, url) => {
    const itemIdx = srcMap.findIndex((s) => s.id && s.id === id);
    if (itemIdx !== -1) {
      srcMap[itemIdx] = {
        ...srcMap[itemIdx],
        url,
      };
      const srcMapCopy = srcMap.slice();
      setSrcMap(srcMapCopy);
      setUploadedImage(reason.key, srcMapCopy);
    }
  };

  const onClickImageBlock = async () => {
    try {
      if (srcMap.length > max_image_count - 1) {
        ToastAndroid.showWithGravity(
          `Can upload only upto ${max_image_count} images`,
          ToastAndroid.SHORT,
          ToastAndroid.CENTER,
        );
        return;
      }
      const id = require("react-native-uuid").default.v1();

      imagePickerHelper({
        onSelectCallback: (response) => {
          if (response.didCancel) {
            return;
          }
          updateSrc({ source: { uri: `${response.uri}` }, id });
        },
        onSuccessCallback: (uploadData) =>
          updateUrlRef.current(id, uploadData.url),
      });
    } catch (e) {}
  };

  return (
    <>
      {imageRequired ? (
        <>
          <Label label={select_images_text} type="images" />
          <View
            style={{
              borderColor: "#e6e6e6f0",
              minHeight: 145,
            }}
          >
            <View style={{ marginVertical: 5, flex: 1 }}>
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {srcMap.map(({ url, source, id }, index) =>
                  url || source ? (
                    <ImageBackground
                      key={index}
                      style={styles.imageBackground}
                      source={url ? { uri: url } : source}
                    >
                      <TouchableOpacity
                        onPress={() => remove(id)}
                        style={styles.imageTouchable}
                      >
                        <View>
                          <CloseIcon />
                          {source && !url && (
                            <View style={styles.imageView}>
                              <ActivityIndicator
                                size="large"
                                color={colors.primary}
                              />
                            </View>
                          )}
                        </View>
                      </TouchableOpacity>
                    </ImageBackground>
                  ) : null,
                )}
                {srcMap.length < 4 && (
                  <AddPhotoButton
                    label="फोटो डालें"
                    onPress={onClickImageBlock}
                  />
                )}
              </View>
            </View>
          </View>
        </>
      ) : null}
    </>
  );
};

export default ImagesUpload;

const styles = StyleSheet.create({
  imageBackground: {
    height: (Dimensions.get("screen").width - 66) / 2,
    width: (Dimensions.get("screen").width - 66) / 2,
    borderRadius: 6,
    borderWidth: 2,
    borderColor: "rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
    borderStyle: "solid",
    marginBottom: 10,
    overflow: "hidden",
  },
  imageTouchable: {
    position: "absolute",
    right: 0,
    top: 0,
    backgroundColor: "#ffffff66",
    borderRadius: 15,
    borderColor: "#e6e6e6",
    borderWidth: 1,
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
  },
  imageView: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.1)",
    justifyContent: "center",
    alignItems: "center",
  },
});
